import { render } from "./myhotelorderDesc.vue?vue&type=template&id=1d21443e&scoped=true"
import script from "./myhotelorderDesc.vue?vue&type=script&lang=js"
export * from "./myhotelorderDesc.vue?vue&type=script&lang=js"

import "./myhotelorderDesc.vue?vue&type=style&index=0&id=1d21443e&lang=scss"
import "./myhotelorderDesc.vue?vue&type=style&index=1&id=1d21443e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d21443e"]])

export default __exports__